module.exports = __webpack_public_path__ + "components/MapControl/svg/Ośrodek zdrowia.svg?d16a5b7c";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Ośrodek zdrowia.svg
// module id = 2063
// module chunks = 0